import { deleteAccount, } from '../types'

const initState = {
  data: null,
  error: null,
  loading: false,
}

export default function deleteAccountReducer (state = initState, action) {
  switch (action.type) {
    
    case deleteAccount.DELETE_ACCOUNT_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        data: null
      }
    
    case deleteAccount.DELETE_ACCOUNT_PENDING:
      return {
        ...state,
        loading: true,
      }
    
    case deleteAccount.DELETE_ACCOUNT_SUCCESS:
      return {
        ...state,
        data: true,
        loading: false,
        error: null,
      }

    default:
      return state
  }
}
